module.exports = __webpack_public_path__ + "static/media/AppBanner.268817f5.jpg";